import { Component } from '@angular/core';
import { RequisitionListComponent } from '../requisition-list/requisition-list.component';
import { TemplateDocumentType } from 'src/app/core/models/document/document-template-model';
import { ClientModel } from 'src/app/core/models/members/client/client.model';
import { ContactModel } from 'src/app/core/models/contact/contact.model';
import { EntityTypeEnum } from "src/app/core/enums/entity-type-id-enum";
import { RequisitionModel } from 'src/app/core/models/requisition/requisition.model';
import { UserBaseModel } from 'src/app/core/models/members/user/user-base.model';
import { GlobalComponent } from 'src/app/global-component';

@Component({
  selector: 'app-requisition-list-check-out',
  templateUrl: './requisition-list-check-out.component.html',
  styleUrls: ['./requisition-list-check-out.component.scss']
})
export class RequisitionListCheckOutComponent extends RequisitionListComponent {

  subtotalCost: number = 0;
  taxCost: number = 0;
  totalCost: number = 0;

  override ngOnInit(): void {

    this.requisitionListService.documentTypes = TemplateDocumentType.Document;

    this.requisitionListService.createdById = this.authMyFileService.currentUserContextValue?.id;

    if (this.startStatus != undefined) {
      this.requisitionListService.status = this.startStatus;
    }

    this.listItemsObservable = this.requisitionListService.resultItems$;
    this.total = this.requisitionListService.total$;
    this.isLoading = this.requisitionListService.loading$;

    const subscr = this.isLoading.subscribe(result => {
      if (result) {
        this.isLoadingVal = true
      } else {
        this.isLoadingVal = false
      }
    });
    this.unsubscribe.push(subscr);

    this.serviceSort(this.requisitionListService, 'modifiedDate', 'desc');

    const subscr2 = this.listItemsObservable.subscribe(result => {
      this.assignRequisitionsToViewModel(result);
      this.totalChange.emit(this.listItems);
    });

    this.unsubscribe.push(subscr2);

  }


  override  assignRequisitionsToViewModel(items: RequisitionModel[]): void {
    this.subtotalCost = 0;
    this.listItems = Object.assign([], items);

    if (items && items.length > 0) {
      items.forEach((data: any) => {
        if (data.client) {
          this.getEntityPhoto(data.client, EntityTypeEnum.Client)
        } else {
          data.client = new ClientModel();
        }
        if (data.account) {
          this.getEntityPhoto(data.account, EntityTypeEnum.Account)
        } else {
          data.account = new ContactModel();
        }

        if (data.user) {
          this.getEntityPhoto(data.user, EntityTypeEnum.User)
        } else {
          data.user = new UserBaseModel();
        }
        if (!data.fullName) {
          data.fullName = `${data.name} ${data.lastName}`;
        }
        this.subtotalCost += data.total;
        data.img = this.getDocumentImageUrl(data.imageUrl);
      });
    }

    this.taxCost = this.subtotalCost * GlobalComponent.taxValue;
    this.totalCost = this.subtotalCost + this.taxCost;
  }
}
